import { store } from "../lib/store.js";
import { supabase } from "../lib/supabase.js";
import { AGENTS } from "../data/agents.js";
import { formatRelativeTime, formatPercent } from "../utils/format.js";

const AGENTS_BY_NAME = new Map(AGENTS.map((agent) => [agent.agentName, agent]));

export function mountDrawer(root) {
  root.innerHTML = `
    <div class="drawer-backdrop" hidden></div>
    <aside class="agent-drawer" hidden role="dialog" aria-modal="true" aria-label="Detalhes do agente">
      <button class="drawer-close" aria-label="Fechar">×</button>
      <div class="drawer-content"></div>
    </aside>
  `;

  const backdrop = root.querySelector(".drawer-backdrop");
  const drawer = root.querySelector(".agent-drawer");
  const content = root.querySelector(".drawer-content");

  // Evita corrida entre cliques rápidos em agentes diferentes: só aplica o
  // resultado da busca se o agente selecionado ainda for o mesmo.
  let currentOrderRequestId = 0;

  function close() {
    store.selectedAgent.set(null);
  }

  function render(agentName, healthMap) {
    if (!agentName) {
      backdrop.hidden = true;
      drawer.hidden = true;
      return;
    }

    const agent = AGENTS_BY_NAME.get(agentName);
    const health = healthMap.get(agentName);

    backdrop.hidden = false;
    drawer.hidden = false;
    content.innerHTML = `
      <h2 class="pixel-heading drawer-title">${escapeHtml(agent?.label ?? agentName)}</h2>
      ${
        health
          ? `
        <dl class="drawer-metrics">
          <dt>Estado</dt><dd>${escapeHtml(health.state)}</dd>
          <dt>Pedido atual</dt><dd data-current-order>${health.state === "idle" ? "nenhum" : "carregando..."}</dd>
          <dt>Última execução</dt><dd>${formatRelativeTime(health.lastExecutionAt)}</dd>
          <dt>Taxa de sucesso (24h)</dt><dd>${formatPercent(health.successRate24h * 100)}</dd>
          <dt>Taxa de escalação (24h)</dt><dd>${formatPercent(health.escalationRate24h * 100)}</dd>
          <dt>Latência média</dt><dd>${health.avgLatencyMs ?? "—"} ms</dd>
        </dl>
      `
          : `<p>Sem dados de execução ainda.</p>`
      }
    `;

    if (health && health.state !== "idle") {
      loadCurrentOrder(agentName);
    }
  }

  async function loadCurrentOrder(agentName) {
    const requestId = ++currentOrderRequestId;
    const { data, error } = await supabase
      .from("agent_executions")
      .select("order_id, status, executed_at")
      .eq("agent_name", agentName)
      .order("executed_at", { ascending: false })
      .limit(1)
      .maybeSingle();

    if (requestId !== currentOrderRequestId) return; // seleção mudou enquanto buscava
    const el = content.querySelector("[data-current-order]");
    if (!el) return;

    if (error) {
      el.textContent = `— (erro: ${error.message})`;
      return;
    }
    el.textContent = data ? `#${data.order_id.slice(0, 8)} (${data.status}, ${formatRelativeTime(data.executed_at)})` : "nenhum registro ainda";
  }

  const unsubscribeSelected = store.selectedAgent.subscribe((agentName) => {
    render(agentName, store.agentHealth.get());
  });
  const unsubscribeHealth = store.agentHealth.subscribe((healthMap) => {
    render(store.selectedAgent.get(), healthMap);
  });

  backdrop.addEventListener("click", close);
  root.querySelector(".drawer-close").addEventListener("click", close);

  return {
    close,
    destroy: () => {
      unsubscribeSelected();
      unsubscribeHealth();
      root.innerHTML = "";
    },
  };
}

function escapeHtml(text) {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}
